import { CommonModule } from '@angular/common';
import { Component, input, Input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CompanyTypeDetailsFormGroup } from '@app/models/form.models';
import { ButtonComponent } from '@app/ui-components/button/button.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-details-tab',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonComponent,
    ValidatedInputComponent,
    TranslatePipe,
  ],
  templateUrl: './details-tab.component.html',
  styleUrl: './details-tab.component.scss',
})
export class DetailsTabComponent {
  @Input() showButtons: boolean = true;
  @Input() disableCodeInput: boolean = true;

  public disableSave = input.required<boolean>();

  public formGroupInput =
    input.required<FormGroup<CompanyTypeDetailsFormGroup>>();

  ngOnInit(): void {
    if (this.disableCodeInput) {
      this.formGroupInput().controls.code.disable();
    }
  }

  public emitCancel = output<void>();
  public emitSave = output<void>();

  save() {
    this.emitSave.emit();
  }
  cancel() {
    this.emitCancel.emit();
  }
}
